import React from 'react';

import './Button.css';

const Button = ({children, color="#F68A1F", type="", clicked, light=false, size=""}) => {
    return (
        <React.Fragment>
            <button className={`btn ${light?`light`: null} ${size}`}
                type={type}
                onClick={clicked}
                style={{color:color, borderColor:color}}>
                    {children}
            </button>
        </React.Fragment>
    );
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/UI/button/Button.js